module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qcirc8-0cca2e4ff25f48044ccf4164c445f608.jpg";